import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {VideoGridElement} from "../../_shared/videos-grid/video-grid-element.model";

@Component({
    selector: 'app-disabledveterans',
    templateUrl: './disabledveterans.component.html',
    styleUrls: ['./disabledveterans.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisabledveteransComponent implements OnInit, AfterViewInit {

  id: number;
  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/C7gmy7qWfMg?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 4: Disabled Veterans\' Exemption with Denny Estrada',
      powerpoint: null
    }
  ];

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {

  }

}
